import React, { useState } from "react";
import { Mail, Send } from "lucide-react";
export const ContactUs = () => {
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    // Here you would typically send the form data to your backend
    await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call
    setSubmitted(true);
    setLoading(false);
  };
  return <div className="py-20 bg-white" data-id="element-113">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <div className="text-center mb-16" data-id="element-115">
          <Mail className="mx-auto h-12 w-12 text-[#6366f1] mb-4" data-id="element-116" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-117">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-600" data-id="element-118">
            Questions? Feedback? We'd love to hear from you.
          </p>
        </div>
        {!submitted ? <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8" data-id="element-119">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-120">
              <div data-id="element-121">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-122">
                  Name
                </label>
                <input type="text" id="name" required value={formState.name} onChange={e => setFormState(prev => ({
              ...prev,
              name: e.target.value
            }))} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none transition-all" placeholder="Your name" data-id="element-123" />
              </div>
              <div data-id="element-124">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-125">
                  Email
                </label>
                <input type="email" id="email" required value={formState.email} onChange={e => setFormState(prev => ({
              ...prev,
              email: e.target.value
            }))} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none transition-all" placeholder="your@email.com" data-id="element-126" />
              </div>
              <div data-id="element-127">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-128">
                  Message
                </label>
                <textarea id="message" required value={formState.message} onChange={e => setFormState(prev => ({
              ...prev,
              message: e.target.value
            }))} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none transition-all min-h-[150px]" placeholder="What's on your mind?" data-id="element-129" />
              </div>
              <button type="submit" disabled={loading} className="w-full py-4 bg-[#d5ff00] text-gray-900 rounded-lg hover:bg-[#c0e600] font-semibold transition-all disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-130">
                {loading ? "Sending..." : <>
                    <Send size={20} data-id="element-131" />
                    Send Message
                  </>}
              </button>
            </form>
          </div> : <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8 text-center" data-id="element-132">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-133">
              Message Sent! 🎉
            </h2>
            <p className="text-gray-600" data-id="element-134">
              Thanks for reaching out! We'll get back to you as soon as
              possible.
            </p>
          </div>}
      </div>
    </div>;
};